export default {
  backup: 'Sicherung',
  downloadTheProjectBackupFile: 'Laden Sie die Projektsicherungsdatei (in JSON) herunter.',
  restoreProject: 'Wiederherstellen...',
  incorrectUsrPwd: 'Falscher Benutzername oder falsches Passwort',
  askDeleteUser: 'Soll dieser Benutzer gelöscht werden?',
  askDeleteTemp: 'Soll diese Vorlage gelöscht werden?',
  askDeleteEnv: 'Soll diese Umgebung gelöscht werden?',
  askDeleteInv: 'Soll dieses Inventar gelöscht werden?',
  askDeleteKey: 'Soll dieser Schlüssel gelöscht werden?',
  askDeleteRepo: 'Soll dieses Repository gelöscht werden?',
  askDeleteProj: 'Soll dieses Projekt gelöscht werden?',
  askDeleteTMem: 'Soll dieses Teammitglied gelöscht werden?',
  edit: 'Bearbeiten',
  nnew: 'Neu',
  keyFormSshKey: 'SSH Schlüssel',
  keyFormLoginPassword: 'Benutzername mit Passwort',
  keyFormNone: 'Keine',
  incorrectUrl: 'Ungültige URL',
  username: 'Benutzername',
  username_required: 'Benutzername ist erforderlich',
  dashboard: 'Oberfläche',
  history: 'Protokoll',
  activity: 'Aktivität',
  settings: 'Einstellungen',
  signIn: 'Einloggen',
  password: 'Passwort',
  changePassword: 'Passwort ändern',
  editUser: 'Benutzer bearbeiten',
  newProject: 'Neues Projekt',
  close: 'Schließen',
  newProject2: 'Neues Projekt...',
  demoMode: 'Demo-Modus',
  task: 'Aufgabe #{expr}',
  youCanRunAnyTasks: 'Sie können jede Anwendungsvorlage ausführen',
  youHaveReadonlyAccess: 'Sie haben nur Lesezugriff',
  taskTemplates: 'Anwendungsvorlagen',
  inventory: 'Inventar',
  environment: 'Umgebung',
  keyStore: 'Schlüsselspeicher',
  repositories: 'Repositories',
  darkMode: 'Dunkler Modus',
  team: 'Team',
  users: 'Benutzer',
  editAccount: 'Account bearbeiten',
  signOut: 'Ausloggen',
  error: 'Fehler',
  refreshPage: 'Seite aktualisieren',
  relogin: 'Neu einloggen',
  howToFixSigninIssues: 'Login-Probleme beheben',
  firstlyYouNeedAccessToTheServerWhereSemaphoreRunni: 'Zuerst benötigen Sie Zugriff auf den Server, auf dem Semaphore ausgeführt wird.',
  executeTheFollowingCommandOnTheServerToSeeExisting: 'Führen Sie den folgenden Befehl auf dem Server aus, um vorhandene Benutzer anzuzeigen:',
  semaphoreUserList: 'semaphore user list',
  youCanChangePasswordOfExistingUser: 'Sie können das Passwort eines vorhandenen Benutzers ändern:',
  semaphoreUserChangebyloginLoginUser123Password: 'semaphore user change-by-login --login user123 --password {makePasswordExample}',
  orCreateNewAdminUser: 'Erstellen Sie einen neuen Administratorbenutzer:',
  close2: 'Schließen',
  semaphore: 'SEMAPHORE',
  dontHaveAccountOrCantSignIn: 'Haben Sie keinen Account oder können Sie sich nicht einloggen?',
  password2: 'Passwort',
  cancel: 'Abbrechen',
  noViews: 'Keine Ansichten',
  addView: 'Ansicht hinzufügen',
  editEnvironment: 'Umgebung bearbeiten',
  deleteEnvironment: 'Umgebung löschen',
  environment2: 'Umgebung',
  newEnvironment: 'Neue Umgebung',
  environmentName: 'Name der Umgebung',
  extraVariables: 'Zusätzliche Variablen',
  enterExtraVariablesJson: 'Geben Sie zusätzliche Variablen im JSON-Format ein...',
  environmentVariables: 'Umgebungsvariablen',
  enterEnvJson: 'Geben Sie Umgebungsvariablen im JSON-Format ein...',
  environmentAndExtraVariablesMustBeValidJsonExample: 'Zusätzliche Variablen und Umgebungsvariablen müssen gültiges JSON sein. Beispiel:',
  dashboard2: 'Obefläche',
  ansibleSemaphore: 'Ansible Semaphore',
  wereSorryButHtmlwebpackpluginoptionstitleDoesntWor: 'Es tut uns leid, aber <%= htmlWebpackPlugin.options.title %> funktioniert nicht richtig ohne JavaScript. Bitte aktivieren Sie es, um fortzufahren.',
  deleteInventory: 'Inventar löschen',
  newInventory: 'Neues Inventar',
  name: 'Name',
  userCredentials: 'Benutzeranmeldeinformationen',
  sudoCredentialsOptional: 'Sudo-Anmeldeinformationen (Optional)',
  type: 'Typ',
  pathToInventoryFile: 'Pfad zur Inventar-Datei',
  enterInventory: 'Inventar eingeben...',
  staticInventoryExample: 'Beispiel für statisches Inventar:',
  staticYamlInventoryExample: 'Beispiel für statisches YAML-Inventar:',
  keyName: 'Schlüsselname',
  loginOptional: 'Login (Optional)',
  usernameOptional: 'Benutzername (Optional)',
  privateKey: 'Privater Schlüssel',
  override: 'Überschreiben',
  useThisTypeOfKeyForHttpsRepositoriesAndForPlaybook: 'Verwenden Sie diesen Schlüsseltyp für HTTPS-Repositories und für Playbooks, die nicht-SSH-Verbindungen verwenden.',
  deleteKey: 'Schlüssel löschen',
  newKey: 'Neuer Schlüssel',
  create: 'Erstellen',
  newTask: 'Neue Aufgabe',
  cantDeleteThe: 'Kann {objectTitle} nicht löschen',
  theCantBeDeletedBecauseItUsedByTheResourcesBelow: 'Kann {objectTitle} nicht löschen, da es von den unten aufgeführten Ressourcen verwendet wird.',
  projectName: 'Projektname',
  allowAlertsForThisProject: 'Alarme für dieses Projekt zulassen',
  telegramChatIdOptional: 'Telegram Chat ID (Optional)',
  maxNumberOfParallelTasksOptional: 'Maximale Anzahl an gleichzeitig ausführbaren Aufgaben (Optional)',
  deleteRepository: 'Repository löschen',
  newRepository: 'Neues Repository',
  urlOrPath: 'URL oder Pfad',
  absPath: 'absoluter Pfad',
  branch: 'Branch',
  accessKey: 'Zugriffsschlüssel',
  credentialsToAccessToTheGitRepositoryItShouldBe: 'Anmeldeinformationen zum Zugriff auf das Git-Repository. Es sollte ein Zugriffsschlüssel sein, der Zugriff auf das Repository gewährt.',
  ifYouUseGitOrSshUrl: 'Wenn Sie Git oder SSH URL verwenden.',
  ifYouUseHttpsOrFileUrl: 'Wenn sie HTTPS oder statische Dateien verwenden.',
  none: 'Keine',
  ssh: 'SSH',
  deleteProject: 'Projekt löschen',
  save: 'Speichern',
  deleteProject2: 'Projekt löschen',
  onceYouDeleteAProjectThereIsNoGoingBackPleaseBeCer: 'Gelöschte Projekte können nicht wiederhergestellt werden. Bitte seien Sie sicher.',
  name2: 'Name *',
  title: 'Titel *',
  description: 'Beschreibung',
  required: 'Erforderlich',
  key: '{expr}',
  surveyVariables: 'Variablen',
  addVariable: 'Variable hinzufügen',
  columns: 'Spalten',
  buildVersion: 'Build Version',
  messageOptional: 'Nachricht (Optional)',
  debug: 'Debug',
  dryRun: 'Dry Run',
  diff: 'Unterschied',
  advanced: 'Erweitert',
  hide: 'Verstecken',
  pleaseAllowOverridingCliArgumentInTaskTemplateSett: 'Bitte erlauben Sie das Überschreiben von CLI-Argumenten in den Einstellungen der Anwendungsvorlage.',
  cliArgsJsonArrayExampleIMyinventoryshPrivatekeythe: 'CLI-Argumente (JSON array). Beispiel: [ "-i", "@myinventory.sh", "--private-key=/there/id_rsa", "-vvvv" ]',
  started: 'Gestartet',
  author: 'Autor',
  duration: 'Dauer',
  stop: 'Stoppen',
  deleteTeamMember: 'Teammitglied löschen',
  team2: 'Team',
  newTeamMember: 'Neues Teammitglied',
  user: 'Benutzer',
  administrator: 'Administrator',
  definesStartVersionOfYourArtifactEachRunIncrements: 'Definiert die Startversion Ihres Artefakts. Jeder Lauf erhöht die Version um 1. Beispiel: 0.0.0',
  forMoreInformationAboutBuildingSeeThe: 'Für weitere Informationen zum Erstellen siehe die',
  taskTemplateReference: 'Referenz für Anwendungsvorlagen',
  definesWhatArtifactShouldBeDeployedWhenTheTaskRun: 'Definiert, welches Artefakt bereitgestellt werden soll, wenn die Aufgabe ausgeführt wird. Beispiel: myapp-{{build_version}}.tar.gz',
  forMoreInformationAboutDeployingSeeThe: 'Für weitere Informationen zur Bereitstellung siehe die',
  taskTemplateReference2: 'Referenz für Anwendungsvorlagen',
  definesAutorunSchedule: 'Definiert den cron-Zeitplan. Beispiel: 0 0 * * *',
  forMoreInformationAboutCronSeeThe: 'Für weitere Informationen zu Cron siehe die',
  cronExpressionFormatReference: 'cron-Ausdrucksformat-Referenz',
  startVersion: 'Start Version',
  example000: 'Beispiel: 0.0.0',
  buildTemplate: 'Anwendungsvorlage erstellen',
  autorun: 'Autorun',
  playbookFilename: 'Name der Playbook-Datei *',
  exampleSiteyml: 'Beispiel: site.yml',
  inventory2: 'Inventar *',
  repository: 'Repository *',
  environment3: 'Umgebung *',
  vaultPassword: 'Vault Passwort',
  vaultPassword2: 'Vault Passwort',
  view: 'Ansicht',
  cron: 'Cron',
  iWantToRunATaskByTheCronOnlyForForNewCommitsOfSome: 'Ich möchte eine Aufgabe nur für neue Commits eines bestimmten Branches ausführen.',
  repository2: 'Repository',
  cronChecksNewCommitBeforeRun: 'Cron überprüft vor dem Ausführen neue Commits',
  readThe: 'Lesen Sie die',
  toLearnMoreAboutCron: 'um mehr über Cron zu erfahren.',
  suppressSuccessAlerts: 'Erfolgsalarme unterdrücken',
  cliArgsJsonArrayExampleIMyinventoryshPrivatekeythe2: 'CLI-Argumente (JSON array). Beispiel: [ "-i", "@myinventory.sh", "--private-key=/there/id_rsa", "-vvvv" ]',
  allowCliArgsInTask: 'CLI-Argumente in der Aufgabe zulassen',
  docs: 'Dokumentation',
  editViews: 'Ansichten bearbeiten',
  newTemplate: 'Neue Vorlage',
  taskTemplates2: 'Anwendungsvorlagen',
  all: 'Alle',
  notLaunched: 'Nicht gestartet',
  by: 'von {user_name} {formatDate}',
  editTemplate: 'Vorlage bearbeiten',
  newTemplate2: 'Neue Vorlage',
  deleteTemplate: 'Vorlage löschen',
  playbook: 'Playbook',
  email: 'E-Mail',
  adminUser: 'Admin Benutzer',
  sendAlerts: 'Alarme senden',
  deleteUser: 'Benutzer löschen',
  newUser: 'Neuer Benutzer',
  re: 'Wiederhole: {getActionButtonTitle}',
  teamMember: '{expr} Teammitglied',
  taskId: 'Task ID',
  version: 'Version',
  status: 'Status',
  start: 'Start',
  actions: 'Aktionen',
  alert: 'Alarm',
  admin: 'Admin',
  role: 'Rolle',
  external: 'Extern',
  time: 'Zeit',
  path: 'pfad',
  gitUrl: 'Git URL',
  sshKey: 'SSH Key',
  lastTask: 'Letzte Aufgabe',
  task2: 'Aufgabe',
  build: 'Build',
  deploy: 'Deploy',
  run: 'Ausführen',
  add: 'Hinzufügen',
  password_required: 'Passwort ist erforderlich',
  name_required: 'Name ist erforderlich',
  user_credentials_required: 'Benutzeranmeldeinformationen sind erforderlich',
  type_required: 'Typ ist erforderlich',
  path_required: 'Pfad zur Inventar-Datei ist erforderlich',
  private_key_required: 'Privater Schlüssel ist erforderlich',
  project_name_required: 'Projektname ist erforderlich',
  repository_required: 'Repository ist erforderlich',
  branch_required: 'Branch ist erforderlich',
  key_required: 'Schlüssel ist erforderlich',
  user_required: 'Benutzer ist erforderlich',
  build_version_required: 'Build version ist erforderlich',
  title_required: 'Titel ist erforderlich',
  isRequired: 'ist erforderlich',
  mustBeInteger: 'Muss eine ganze Zahl (Integer) sein',
  mustBe0OrGreater: 'Muss 0 oder größer sein',
  start_version_required: 'Start version ist erforderlich',
  playbook_filename_required: 'Name der Playbook-Datei ist erforderlich',
  inventory_required: 'Inventar ist erforderlich',
  environment_required: 'Umgebung ist erforderlich',
  email_required: 'E-Mail ist erforderlich',
  build_template_required: 'Build-Vorlage ist erforderlich',
  Task: 'Aufgabe',
  Build: 'Build',
  Deploy: 'Deploy',
  Run: 'Ausführen',

};
